export default {
    serverURI: 'https://mypa.website:3900',
    fixedLayout: false,
    hideLogoOnMobile: false
  }


// WEBPACK FOOTER //
// ./src/vuex/api/services/config.js